import { Table, Tag } from "antd";
import React from "react";
import TableUser from "./table_user";
import { useDraftDialogRefine } from "hook/draft/dialog/useDraftDialogRefine";
import TableAction from "./table_action";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const SUPPORT_STATUS = {
  supporting: "Đang chờ sửa",
  working: "Đang sửa",
  finished: "Hoàn thành",
};

const DetailTable = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  const isNotEdit = tab === "not_edit";
  const isEdit = tab === "edit";
  const data = useDraftDialogRefine();

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    // {
    //   title: "Tạo lúc",
    //   dataIndex: "createAt",
    //   key: "createAt",
    //   render: (value) => getTime(value, "DD/MM/YYYY HH:mm:ss"),
    // },
    {
      title: "Trích đoạn",
      dataIndex: "slot",
      key: "slot",
      align: "center",
      render: (value) => <span> {value}</span>,
    },
    {
      title: "Số từ",
      dataIndex: "charaters",
      key: "charaters",
    },
    {
      title: "Câu mở đầu",
      dataIndex: "sentences",
      key: "sentences",
      width: 300,
      render: (value) => getFirstSentence(value),
    },
    {
      title: "Speaker",
      dataIndex: "sentences",
      key: "speaker",
      align: "center",
      render: (value) => getSpeakerNumber(value),
    },
    {
      title: "Hỗ trợ viên",
      dataIndex: "supporter",
      key: "supporter",
      render: (_, record) => <TableUser data={record} />,
    },
    {
      title: "Đoạn sentences",
      dataIndex: "sentences",
      key: "sentences",
      render: (value) => getSentences(value),
    },
    {
      title: "Đánh giá",
      dataIndex: "rated",
      key: "rated",
      render: (value) => getRated(value),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: (value) => getStatus(value),
    },
    {
      title: "#",
      dataIndex: "qc",
      key: "qc",
      fixed: "right",
      render: (_, record) => <TableAction record={record} />,
    },
  ];

  const getStatus = (value) => {
    const label = SUPPORT_STATUS[value];
    return <Tag>{label}</Tag>;
  };

  const getSentences = (value) => {
    const edited = value?.filter((v) => v?.edited)?.length || 0;
    const total = value?.length || 0;
    return `Đã sửa ${edited}/${total}`;
  };

  const getFirstSentence = (sens) => {
    const first =
      sens?.length > 0 ? sens?.map((s) => s?.text)?.join("\n\n") : "";
    return first?.slice(0, 100) + "...";
  };

  const getSpeakerNumber = (sens) => {
    const speakers = sens?.map((s) => s?.speaker);
    const uniqSpeaker = [...new Set(speakers)];
    const label = uniqSpeaker?.join(", ");
    return `(${uniqSpeaker?.length || 0}) ${label}`;
  };

  const getRated = (value) => {
    const label = value ? (
      <span style={{ color: "green" }}>Đã QC</span>
    ) : (
      <span style={{ color: "red" }}>Chưa QC</span>
    );
    return label;
  };

  // -------------------------- MAIN ----------------------------
  if (isEdit || isNotEdit) {
    return (
      <Table
        size="small"
        bordered
        columns={columns}
        dataSource={data || []}
        loading={data === null}
        rowKey={"id"}
        scroll={{ x: "auto" }}
      />
    );
  }
};
export default DetailTable;
